import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/login/lee-letras-b.png'
import _imports_1 from '@/assets/img/menu/huellita-blanca.png'
import _imports_2 from '@/assets/img/login/lee-blanco.png'


const _withScopeId = n => (_pushScopeId("data-v-44f45c4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "CajitaMenu",
  id: "CajitaMenuT"
}
const _hoisted_2 = { class: "HeaderMenu" }
const _hoisted_3 = { class: "CajitaMenuOpt" }
const _hoisted_4 = {
  key: 0,
  src: _imports_1
}
const _hoisted_5 = {
  key: 0,
  src: _imports_1
}
const _hoisted_6 = {
  key: 0,
  src: _imports_1
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-bars",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_8 = { class: "BodyMenu" }
const _hoisted_9 = {
  key: 1,
  class: "contentMenuModal animate__animated animate__slideInLeft animate__faster",
  id: "contentMenuModal"
}
const _hoisted_10 = { class: "FotoPerfil" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circular--portrait" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1))
const _hoisted_13 = { class: "TextNombre" }
const _hoisted_14 = {
  key: 0,
  src: _imports_1
}
const _hoisted_15 = {
  key: 0,
  src: _imports_1
}
const _hoisted_16 = {
  key: 0,
  src: _imports_1
}
const _hoisted_17 = {
  key: 0,
  class: "Cargando"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"wrapper\" data-v-44f45c4e><div class=\"circle circle1\" data-v-44f45c4e></div><div class=\"circle circle2\" data-v-44f45c4e></div><div class=\"circle circle3\" data-v-44f45c4e></div><div class=\"shadow\" data-v-44f45c4e></div><div class=\"shadow\" data-v-44f45c4e></div><div class=\"shadow\" data-v-44f45c4e></div><span data-v-44f45c4e>Cargando</span></div>", 1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VentasVue = _resolveComponent("VentasVue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.abreMenuModal())),
          class: "LogoTienda",
          src: _imports_0
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.CambiaVista('Ventas',1))),
            id: "Ventas",
            class: "cajitasMenuOpti CMO active"
          }, [
            (_ctx.Ventas)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            _createTextVNode(" Ventas")
          ]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.CambiaVista('Inventario',1))),
                id: "Inventario",
                class: "cajitasMenuOpti CMO"
              }, [
                (_ctx.Inventario)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                  : _createCommentVNode("", true),
                _createTextVNode(" Inventario")
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.CambiaVista('Usuarios',1))),
                id: "Usuarios",
                class: "cajitasMenuOpti CMO"
              }, [
                (_ctx.Usuarios)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                  : _createCommentVNode("", true),
                _createTextVNode(" Usuarios")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.CambiaVista('Cerrar',1))),
            id: "Cerrar",
            class: "cajitasMenuOpti"
          }, "Cerrar sesión")
        ]),
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.abreMenuModal())),
          class: "btn btn-outline-light rounded-pill BtnAbremenus",
          type: "button"
        }, [
          _createTextVNode("Menu "),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.Ventas)
          ? (_openBlock(), _createBlock(_component_VentasVue, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      (_ctx.LHAModalMenu)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "MenuModal animate__animated animate__fadeIn animate__faster",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.abreMenuModal())),
            id: "MenuModal"
          }))
        : _createCommentVNode("", true),
      (_ctx.LHAModalMenu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("i", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.abreMenuModal())),
              class: "bi bi-x iconCerrar"
            }),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.DataGeneral[0].USU_NOMBRE), 1)
            ]),
            _createElementVNode("div", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.CambiaVista('Ventas',2))),
              id: "Ventas2",
              class: "col-12 CajitasVIRU CajitasV"
            }, [
              (_ctx.Ventas)
                ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                : _createCommentVNode("", true),
              _createTextVNode(" Ventas")
            ]),
            (_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.CambiaVista('Inventario',2))),
                  id: "Inventario2",
                  class: "col-12 CajitasVIRU CajitasI"
                }, [
                  (_ctx.Inventario)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Inventario")
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.CambiaVista('Usuarios',2))),
                  id: "Usuarios2",
                  class: "col-12 CajitasVIRU CajitasU"
                }, [
                  (_ctx.Usuarios)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Usuarios")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.CambiaVista('Cerrar',2))),
              id: "Cerrar2",
              class: "col-12 CajitasVIRU CajitasU"
            }, "Cerrar sesión")
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.Cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
      : _createCommentVNode("", true)
  ], 64))
}